/**
 * Por que o saldo do cliente não está na tela — F208.
 *
 * O recebimento recebia só o saldo de vale (ou o crédito), e saldo nulo queria
 * dizer "sem cliente". Mas o saldo também vem nulo quando a consulta ainda não
 * voltou, quando o usuário não pode ler vale, ou quando a leitura falhou — e o
 * caixa, com o cliente escolhido na tela, lia "Escolha o cliente". Cada caso
 * tem a sua frase, e só o primeiro fala em escolher cliente.
 */
export type CustomerLookup =
  | { readonly state: 'no-customer' }
  | { readonly state: 'loading' }
  | { readonly state: 'forbidden' }
  | { readonly state: 'error'; readonly retry: () => void }
  | { readonly state: 'ready' }

export const customerLookup = (
  query: {
    readonly isSuccess: boolean
    readonly isError: boolean
    readonly refetch: () => unknown
  },
  context: { readonly hasCustomer: boolean; readonly allowed: boolean }
): CustomerLookup => {
  if (!context.hasCustomer) return { state: 'no-customer' }
  if (!context.allowed) return { state: 'forbidden' }
  if (query.isSuccess) return { state: 'ready' }
  if (query.isError) {
    return {
      state: 'error',
      retry: () => {
        void query.refetch()
      },
    }
  }
  return { state: 'loading' }
}
